import { Container, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Footer from "../pages/public_payment/Footer";
import React from "react";
import paymentImage from "../pages/public_payment/payhuman.png";
import PwaInstallPrompt from "../components/PwaInstallPrompt";

export default function AppLayout({ children }) {
  const [main, setMain] = React.useState();

  let loanState = useSelector((state) => state?.loanduesState);
  let settingsState = useSelector((state) => state?.settingsState);

  React.useEffect(() => {
    console.log("LOANS:", loanState);
  }, [loanState]);

  React.useEffect(() => {
    try {
      let mainStr = settingsState?.data?.data?.main;
      let mainData = typeof mainStr === "string" ? JSON.parse(mainStr) : mainStr;
      setMain(mainData);
      if (mainData) localStorage.setItem("settings", JSON.stringify(mainData));
    } catch {
      const cached = localStorage.getItem("settings");
      if (cached) setMain(JSON.parse(cached));
    }
  }, [settingsState]);

  return (
    <Container fluid className="p-0 min-vh-100 d-flex flex-column">
      <Row className="g-0 flex-grow-1">

        {/* LEFT PANEL */}
        <Col xs={12} md={6} className="d-flex flex-column bg-white">

          {/* Scrollable content */}
          <div className="flex-grow-1 overflow-auto px-3 pt-3">
            {children}
          </div>

          <PwaInstallPrompt />

          {/* Mobile footer */}
          <div className="d-md-none">
            <Footer />
          </div>
        </Col>

        {/* RIGHT PANEL (Desktop Only) */}
        <Col
          md={6}
          className="d-none d-md-flex flex-column justify-content-between align-items-center bg-light"
        >
          {/* Logo */}
          <div className="w-100 d-flex justify-content-end p-4">
            {main?.icon && (
              <img
                src={main.icon}
                alt="Company Logo"
                style={{ height: 60, objectFit: "contain" }}
              />
            )}
          </div>

          {/* Illustration */}
          <div className="flex-grow-1 d-flex align-items-center justify-content-center p-4">
            <img
              src={paymentImage}
              alt="Payment Illustration"
              className="img-fluid"
              style={{ maxHeight: "70vh", objectFit: "contain" }}
            />
          </div>

          {/* Desktop footer */}
          <footer className="w-100 text-center border-top py-2 bg-white">
            <small className="text-muted">
              © All Rights Reserved | Powered by{" "}
              <span style={{ fontWeight: 600, color: "#007bff" }}>icrats</span>
            </small>
          </footer>
        </Col>
      </Row>
    </Container>
  );
}
